import { eventRegistry } from '../events/registry';
import { listen } from './event';
import { IDataLayer } from '../../types';
import tealium from '../tealium';

// TODO: do we need this router or can each individual track file listen for its own events?
export default class AnalyticsEventRouter {
  spaDataLayer: IDataLayer | null = null;
  spaUrlPayload: IDataLayer | null = null;

  constructor() {
    window.site = window.site || {};
    window.site.track = window.site.track || {};
    window.site.track.evtLink = tealium.evtLink.bind(window.tealium);

    this.urlWatcher();
    this.logoHandler();

    listen(window, ['cart.offerSuccess'], (event: CustomEvent) => {
      this.onOffer('offerSuccessful', event);
    });
    listen(window, ['cart.offerFail'], (event: CustomEvent) => {
      this.onOffer('offerFailed', event);
    });
    listen(window, ['cart.offerRemove'], (event: CustomEvent) => {
      this.onOffer('offerRemove', event);
    });
    listen(window, ['cart.sampleAdded'], (event: CustomEvent) => {
      this.onSampleAdded(event);
    });
    listen(window, ['cart.sampleRemoved'], (event: CustomEvent) => {
      this.onSampleRemoved(event);
    });
    listen(window, ['cart.removeFromCart'], (event: CustomEvent) => {
      this.onRemoveFromCart(event);
    });
    listen(window, ['cart.addToCart'], (event: CustomEvent) => {
      this.onAddToCart(event);
    });
    listen(window, ['openCart'], (event: CustomEvent) => {
      this.onAddToCart(event);
    });
    listen(window, ['iam.registration'], (event: CustomEvent) => {
      this.onRegistration(event);
    });
    listen(window, ['iam.registrationFailed'], (event: CustomEvent) => {
      this.onRegistrationFailed(event);
    });
    listen(window, ['iam.accountRoute'], (event: CustomEvent) => {
      this.onAccountRoute(event);
    });
    listen(window, ['iam.signIn'], (event: CustomEvent) => {
      this.onSignIn(event);
    });
    listen(window, ['iam.signInFailed'], (event: CustomEvent) => {
      this.onSignInFailed(event);
    });
    listen(window, ['iam.emailSignup'], (event: CustomEvent) => {
      this.onEmailSignup(event);
    });
    listen(window, ['nav.globalNavClick'], (event: CustomEvent) => {
      this.onGlobalNavClick(event);
    });
    listen(window, ['nav.subNavClick'], (event: CustomEvent) => {
      this.onSubNavClick(event);
    });
    listen(window, ['analytics.overlayProductClick'], (event: CustomEvent) => {
      this.onOverlayProductClick(event);
    });
    listen(window, ['analytics.productClick'], (event: CustomEvent) => {
      this.onProductClick(event);
    });
    listen(window, ['analytics.quickshop.clicked'], (event: CustomEvent) => {
      this.onQuickshopClick(event);
    });
    listen(window, ['searchOverlayDisplayedEvent'], () => {
      this.onSearchOverlayDisplayed();
    });
    listen(window, ['cart.drawer.clicked'], (event: CustomEvent) => {
      this.onCartDrawer(event);
    });
    listen(window, ['VTOActionsTracking'], (event: CustomEvent) => {
      this.onVTOActionsTracking(event);
    });
    listen(window, ['oab.SelectStore'], (event: CustomEvent) => {
      this.oabSelectStore(event);
    });
    listen(window, ['oab.SelectService'], (event: CustomEvent) => {
      this.oabSelectService(event);
    });
    listen(window, ['oab.SelectDateTime'], (event: CustomEvent) => {
      this.oabSelectDateTime(event);
    });
    listen(window, ['oab.AppointmentBooked'], (_event: CustomEvent) => {
      this.onOabAppointmentClick('appointmentBooked');
    });
    listen(window, ['oab.addtocalendar'], (_event: CustomEvent) => {
      this.onOabAppointmentClick('addtocalendar');
    });
    listen(window, ['oab.continueShopping'], (event: CustomEvent) => {
      this.onOabContinueShoppingClick(event);
    });
    listen(window, ['oab.appointmentCancelandStart'], (_event: CustomEvent) => {
      this.onOabAppointmentClick('cancelandstart');
    });
    listen(window, ['oab.appointmentEdit'], (_event: CustomEvent) => {
      this.onOabAppointmentClick('appointmentedit');
    });
    listen(window, ['loyaltyActionsTracking'], (event: CustomEvent) => {
      this.onLoyaltyActionsTracking(event);
    });
    listen(window, ['cartPaymentActionsTracking'], (event: CustomEvent) => {
      this.onCartPaymentActionsTracking(event);
    });
    listen(window, ['findationWidget'], (event: CustomEvent) => {
      this.onfindationWidgetTracking(event);
    });
    listen(
      window,
      ['cart.overlay.opened', 'cart.overlay.closed'],
      (event: CustomEvent) => {
        this.onCartOverlayTracking(event);
      },
    );
    listen(window, ['phx:trackEvent'], (event: CustomEvent) => {
      // add additional cases for new event
      switch (event?.detail?.event_name) {
        case 'analytics.sortEvent':
          this.onSortClick(event);
          break;
        case 'analytics.searchPageLoadedEvent':
          this.onSearchPageLoadedEvent(event);
          break;
        case 'analytics.searchPredictedEvent':
          this.onSearchPredicted(event);
          break;
        case 'analytics.bannerPromo':
          this.onBannerPromoClick(event);
          break;
        case 'analytics.gnavPromo':
          this.onGnavPromoClick(event);
          break;
        case 'analytics.filterComplete':
          this.onFilterComplete(event);
          break;
        case 'analytics.categoryToggle':
          this.onCategoryToggle(event);
          break;
        case 'analytics.spaPageLoadedEvent':
          this.onDatalayerUpdate(event);
          break;
        default:
          break;
      }
    });
    listen(window, ['altImage.clicked'], (event: CustomEvent) => {
      this.onAltImageClick(event);
    });
    listen(window, ['pdp.accordion'], (event: CustomEvent) => {
      this.onPdpAccordion(event);
    });
    listen(window, ['pdp.onReviewSubmit'], (event: CustomEvent) => {
      this.onPdpReviewSubmit(event);
    });
    listen(window, ['pdp.onReviewStart'], (event: CustomEvent) => {
      this.onPdpReviewStart(event);
    });
    listen(window, ['pdp.onReviewSort'], (event: CustomEvent) => {
      this.onPdpReviewSort(event);
    });
    listen(window, ['analytics.containerPromo'], (event: CustomEvent) => {
      this.onBannerPromoClick(event);
    });
    listen(window, ['profile.tabswitch'], (event: CustomEvent) => {
      this.onprofileTabSwitch(event);
    });
    listen(window, ['profile.orderDetail'], (event: CustomEvent) => {
      this.onOrderDetail(event);
    });
    listen(window, ['profile.orderItem'], (event: CustomEvent) => {
      this.onOrderItem(event);
    });
    listen(window, ['profile.update'], (event: CustomEvent) => {
      this.onprofileUpdate(event);
    });
  }

  // TODO: move this data translation to the track file on next refactor
  onDatalayerUpdate(event: CustomEvent) {
    if (!tealium.isSpaReady) {
      tealium.isSpaReady = true;
      return;
    }

    const datalayerUpdated = event?.detail?.payload || null;
    if (datalayerUpdated) {
      this.onSpaPageLoaded(null, datalayerUpdated);
    }
  }

  urlWatcher() {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    let prevUrl: string = window.location.href;
    let prevTitle: string = document.title;

    const handleUrlChange = () => {
      const currentUrl: string = window.location.href;
      const currentTitle: string = document.title;

      const prevParsed = new URL(prevUrl);
      const currentParsed = new URL(currentUrl);

      const samePath =
        prevParsed.origin === currentParsed.origin &&
        prevParsed.pathname === currentParsed.pathname;

      if (!samePath || prevTitle !== currentTitle) {
        const previousUrl = prevUrl;
        prevUrl = currentUrl;

        this.waitForTitleChange(() => {
          prevTitle = document.title;
          this.onSpaPageLoaded({ previousUrl, currentUrl }, null);
        });
      }
    };

    // Proxy `pushState` to observe SPA navigation
    history.pushState = new Proxy(originalPushState, {
      apply: (target, thisArg, args) => {
        const result = Reflect.apply(target, thisArg, args);
        handleUrlChange();
        return result;
      },
    });

    // Proxy `replaceState` to observe SPA navigation
    history.replaceState = new Proxy(originalReplaceState, {
      apply: (target, thisArg, args) => {
        const result = Reflect.apply(target, thisArg, args);
        handleUrlChange();
        return result;
      },
    });

    // This detects user hitting back/forward
    window.addEventListener('popstate', handleUrlChange);
  }

  waitForTitleChange(callback: () => void): void {
    const initialTitle: string = document.title;
    const titleElement = document.head.querySelector('title');

    if (!titleElement) {
      callback();
      return;
    }

    const observer = new MutationObserver(() => {
      if (document.title !== initialTitle) {
        observer.disconnect();
        callback();
      }
    });

    observer.observe(titleElement, { childList: true });
  }

  logoHandler(): void {
    const homeLink =
      document.querySelector<HTMLAnchorElement>('header a[href="/"]');
    if (!homeLink) return;

    if (!homeLink.dataset.eventAdded) {
      homeLink.addEventListener('click', (event: Event) => {
        event.preventDefault();
        window.location.href = '/';
      });
      homeLink.dataset.eventAdded = 'true';
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSpaPageLoaded(urlPayload?: any, datalayerPayload?: any) {
    const eventName = 'pageLoaded';

    if (urlPayload) {
      this.spaUrlPayload = urlPayload;
    }

    if (datalayerPayload) {
      this.spaDataLayer = datalayerPayload;
    }

    if (this.spaDataLayer && this.spaUrlPayload) {
      const pageLoaded = {
        ...this.spaUrlPayload,
        ...this.spaDataLayer,
      };
      if (pageLoaded) {
        eventRegistry[eventName]?.(eventName, pageLoaded);
      }

      this.spaDataLayer = null;
      this.spaUrlPayload = null;
    }
  }

  onSearchPageLoadedEvent(event: CustomEvent) {
    const eventName = 'searchPageLoaded';
    const searchPageLoaded = event?.detail?.payload || '';
    if (searchPageLoaded) {
      eventRegistry[eventName]?.(eventName, searchPageLoaded);
    }
  }

  onSearchPredicted(event: CustomEvent) {
    const eventName = 'searchPredicted';
    const searchPredicted = event?.detail?.payload?.value || '';
    if (searchPredicted) {
      eventRegistry[eventName]?.(eventName, searchPredicted);
    }
  }

  onSearchOverlayDisplayed() {
    const eventName = 'searchOverlayDisplayed';
    eventRegistry[eventName]?.(eventName, {});
  }

  onSortClick(event: CustomEvent) {
    const eventName = 'sortClick';
    const sortOption = event?.detail?.payload?.value || '';
    if (sortOption) {
      eventRegistry[eventName]?.(eventName, {
        sort_option: sortOption,
      });
    }
  }

  onVTOActionsTracking(event: CustomEvent) {
    const eventName = 'VTOActionsTracking';
    const eventData = event?.detail || {};
    eventRegistry[eventName]?.(eventName, eventData);
  }

  onLoyaltyActionsTracking(event: CustomEvent) {
    const eventName = 'loyaltyTag';
    const eventData = event?.detail || {};
    if (eventData?.event_label) {
      eventRegistry[eventName]?.(eventName, eventData);
    }
  }

  onCartPaymentActionsTracking(event: CustomEvent) {
    const eventName = 'cartPayment';
    const eventData = event?.detail || {};
    if (eventData.paymentMode) {
      eventRegistry[eventName]?.(eventName, eventData);
    }
  }

  onfindationWidgetTracking(event: CustomEvent) {
    const eventName = 'findationWidget';
    const eventData = event?.detail || {};
    if (eventData?.event_label) {
      eventRegistry[eventName]?.(eventName, eventData);
    }
  }

  onCartOverlayTracking(event: CustomEvent) {
    const eventName = 'cartOverlay';
    const eventData = event?.detail || {};
    eventRegistry[eventName]?.(eventName, eventData);
  }

  onProductClick(event: CustomEvent) {
    const eventName = 'productClick';
    const productId = event?.detail?.productId || '';
    if (productId) {
      eventRegistry[eventName]?.(eventName, {
        product_id: [`PROD${productId}`],
      });
    }
  }

  onBannerPromoClick(event: CustomEvent) {
    const eventName = 'bannerClick';
    // We only want dispatch a analytics call when a banner have a valid title and url
    const promoBanner =
      event.detail.banner_promo_title != null &&
      event.detail.banner_promo_url != null;
    if (promoBanner) {
      eventRegistry[eventName]?.(eventName, event.detail);
    }
  }

  onOverlayProductClick(event: CustomEvent) {
    const eventName = 'productClick';
    const productId = event?.detail?.productId || '';
    if (productId) {
      eventRegistry[eventName]?.(eventName, {
        product_id: [`PROD${productId}`],
        is_overlay: true,
      });
    }
  }

  onOabAppointmentClick(eventName: string) {
    eventRegistry[eventName]?.(eventName, {});
  }

  onOabContinueShoppingClick(event: CustomEvent) {
    const eventName = 'continueShopping';
    const eventData = event?.detail || {};
    eventRegistry[eventName]?.(eventName, eventData);
  }

  oabSelectStore(event: CustomEvent) {
    const eventName = 'SelectStore';
    const step_number = event?.detail?.payload?.step || '1';
    eventRegistry[eventName]?.(eventName, {
      step_number: step_number,
    });
  }

  oabSelectService(event: CustomEvent) {
    const eventName = 'SelectService';
    const serviceName = event?.detail?.payload?.serviceName || '';
    eventRegistry[eventName]?.(eventName, {
      serviceType: serviceName,
    });
  }

  oabSelectDateTime(event: CustomEvent) {
    const eventName = 'SelectDateTime';
    const dateTime = event?.detail?.payload?.dateTime || '1';
    eventRegistry[eventName]?.(eventName, {
      date_time: dateTime,
    });
  }

  onQuickshopClick(event: CustomEvent) {
    const eventName = 'quickView';
    const productId = event?.detail?.productId || '';
    if (productId) {
      eventRegistry[eventName]?.(eventName, {
        product_id: [`PROD${productId}`],
      });
    }
  }

  onNavClick(event: CustomEvent) {
    const eventName = 'navigationClick';
    const promoName = event?.detail?.event?.target?.innerText || '';
    eventRegistry[eventName]?.(eventName, {
      promo_name: promoName,
    });
  }

  onGlobalNavClick(event: CustomEvent) {
    this.onNavClick(event);
  }

  onSubNavClick(event: CustomEvent) {
    this.onNavClick(event);
  }

  onRegistration(event: CustomEvent) {
    const eventName = 'registration';
    const accountReferrer = event?.detail?.provider || '';
    const accountSource = event?.detail?.source || '';
    const accountType = event?.detail?.type || '';
    const userId = event?.detail?.userId || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_source: accountSource,
      account_type: accountType,
      USER_ID: userId,
    });
  }

  onRegistrationFailed(event: CustomEvent) {
    const eventName = 'registrationFailed';
    const accountReferrer = event?.detail?.provider || '';
    const accountSource = event?.detail?.source || '';
    const accountType = event?.detail?.type || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_source: accountSource,
      account_type: accountType,
    });
  }

  onPdpReviewSubmit(event: CustomEvent) {
    const eventName = 'writeaReview';
    const reviewProdId = event?.detail?.prodID || '';
    if (reviewProdId) {
      eventRegistry[eventName]?.(eventName, {
        review_prodid: reviewProdId,
      });
    }
  }

  onPdpReviewStart(event: CustomEvent) {
    const eventName = 'reviewStart';
    const reviewProdId = event?.detail?.prodID || '';
    eventRegistry[eventName]?.(eventName, {
      review_prodid: reviewProdId,
    });
  }

  onPdpReviewSort(event: CustomEvent) {
    const eventName = 'reviewSort';
    const reviewSortVal = event?.detail?.sortVal || '';
    const reviewSortProdId = event?.detail?.prodID || '';
    if (reviewSortVal) {
      eventRegistry[eventName]?.(eventName, {
        review_sort: reviewSortVal,
        review_prodid: reviewSortProdId,
      });
    }
  }

  onAccountRoute(event: CustomEvent) {
    const eventName = 'accountroute';
    const accountRouteVal = event?.detail?.route || '';
    if (accountRouteVal) {
      eventRegistry[eventName]?.(eventName, {
        account_route: accountRouteVal,
      });
    }
  }

  onSignIn(event: CustomEvent) {
    const eventName = 'signin';
    const accountReferrer = event?.detail?.provider || '';
    const accountRememberMe = event?.detail?.rememberMe || '';
    const accountSource = event?.detail?.source || '';
    const userId = event?.detail?.userId || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_rememberme: accountRememberMe,
      account_source: accountSource,
      USER_ID: userId,
    });
  }

  onSignInFailed(event: CustomEvent) {
    const eventName = 'signinFailed';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: event?.detail?.provider || '',
      account_source: event?.detail?.source || '',
      account_type: event?.detail?.type || '',
    });
  }

  onEmailSignup(event: CustomEvent) {
    const eventName = 'emailSignup';
    eventRegistry[eventName]?.(eventName, event?.detail || {});
  }

  onOffer(eventName: string, event: CustomEvent) {
    const offerCode = event?.detail || '';
    if (offerCode) {
      eventRegistry[eventName]?.(eventName, {
        offer_code: ['offer code' + ' - ' + offerCode],
      });
    }
  }

  onSampleAdded(event: CustomEvent) {
    const eventName = 'checkoutSampleAdded';
    const sampleProductName = event?.detail?.prodName || '';
    const sampleProductSku = event?.detail?.prodSku || '';
    if (sampleProductSku && sampleProductName) {
      eventRegistry[eventName]?.(eventName, {
        sample_product_name: sampleProductName,
        sample_product_sku: sampleProductSku,
      });
    }
  }

  onSampleRemoved(event: CustomEvent) {
    const eventName = 'checkoutSampleRemoved';
    const sampleProductName = event?.detail?.prodName || '';
    const sampleProductSku = event?.detail?.prodSku || '';
    if (sampleProductSku && sampleProductName) {
      eventRegistry[eventName]?.(eventName, {
        cart_sample: [sampleProductName + ' - SKU' + sampleProductSku],
      });
    }
  }

  onRemoveFromCart(event: CustomEvent) {
    const eventName = 'removeFromCart';
    const productSku = event?.detail?.product_sku || '';
    if (productSku) {
      eventRegistry[eventName]?.(eventName, {
        product_sku: [`SKU${productSku}`],
        is_pincer_cart: true,
      });
    }
  }

  onAddToCart(event: CustomEvent) {
    const eventName = 'addToCart';
    const productSku = event?.detail?.product_sku || '';
    const productCode = event?.detail?.skuId || '';
    const quantity = event?.detail?.quantity || 0;
    const html = event?.detail?.html || '';
    if (productSku) {
      eventRegistry[eventName]?.(eventName, {
        product_sku: [`SKU${productSku}`],
        is_pincer_cart: true,
      });
    } else if (productCode && html) {
      eventRegistry[eventName]?.(eventName, {
        // this is a data layer specific naming convention
        product_product_code: [productCode],
        product_quantity: [quantity],
        is_bf_cart: true,
      });
    }
  }

  onCartDrawer(event: CustomEvent) {
    const eventName = 'cartDrawer';
    const drawerItemCategory = event?.detail?.cartDrawerCategory || '';
    const drawerItemAction = event?.detail?.cartDrawerAction || '';
    const drawerItemCta = event?.detail?.cartDrawerCta || '';
    if (drawerItemCta) {
      eventRegistry[eventName]?.(eventName, {
        cartDrawerName: drawerItemCategory,
        cartDrawerCategory: drawerItemCategory,
        cartDrawerAction: drawerItemAction,
        cartDrawerCta: drawerItemCta,
      });
    }
  }

  onAltImageClick(event: CustomEvent) {
    const eventName = 'altImage';
    const altImageClickedAction = event?.detail?.altImageAction || '';
    if (altImageClickedAction) {
      eventRegistry[eventName]?.(eventName, {
        altImageAction: altImageClickedAction,
        altImagePosition: event?.detail?.altImagePosition,
      });
    }
  }

  onPdpAccordion(event: CustomEvent) {
    const eventName = 'pdpAccordion';
    const productCardHeader = event?.detail?.productCardLabel || '';
    const productCardType = event?.detail?.productCardAction
      ? 'expand'
      : 'collapse';
    if (productCardHeader) {
      eventRegistry[eventName]?.(eventName, {
        eventAction: productCardType,
        eventLabel: productCardHeader,
      });
    }
  }

  onprofileTabSwitch(event: CustomEvent) {
    const eventName = 'tabSwitch';
    const tabSwitchVal = event?.detail || '';
    // We only want dispatch a analytics call when a switch have a valid tabSwitchVal
    if (tabSwitchVal) {
      eventRegistry[eventName]?.(eventName, {
        profile_action: 'account_tab_switch',
        profile_value: tabSwitchVal,
      });
    }
  }

  onOrderDetail(event: CustomEvent) {
    const eventName = 'orderDetails';
    const orderDetail = event?.detail || '';
    // We only want dispatch a analytics call when user clicked orderDetail with valid detail
    if (orderDetail) {
      eventRegistry[eventName]?.(eventName, {
        profile_action: 'order_details',
        profile_value: orderDetail,
      });
    }
  }

  onOrderItem(event: CustomEvent) {
    const eventName = 'orderItem';
    const orderItem = event?.detail || '';
    // We only want dispatch a analytics call when user clicked orderItem with valid detail
    if (orderItem) {
      eventRegistry[eventName]?.(eventName, {
        profile_action: 'order_item',
        profile_value: orderItem,
      });
    }
  }

  onprofileUpdate(event: CustomEvent) {
    const eventName = 'profileUpdate';
    const profileupdateLable = event?.detail || '';
    // We only want dispatch a analytics call when user update profile with valid details
    if (profileupdateLable) {
      eventRegistry[eventName]?.(eventName, {
        profile_action: profileupdateLable + '_update',
        profile_value: profileupdateLable,
      });
    }
  }

  onGnavPromoClick(event: CustomEvent) {
    const eventName = 'navigationClick';
    const promoName = event?.detail?.payload || '';
    if (promoName) {
      eventRegistry[eventName]?.(eventName, promoName);
    }
  }

  onFilterComplete(event: CustomEvent) {
    const eventName = 'filterComplete';
    eventRegistry[eventName]?.(eventName, {
      payload: event.detail.payload,
    });
  }

  onCategoryToggle(event: CustomEvent) {
    const eventName = 'categoryToggle';
    const categoryElement = (event.target as HTMLElement)
      .nextElementSibling as HTMLElement;
    const status =
      categoryElement?.style.display == 'block' ? 'collapse' : 'expand';

    eventRegistry[eventName]?.(eventName, {
      payload: {
        category: event.detail.payload.category,
        status,
      },
    });
  }
}
// TODO: deal with this

/*
    // Event specific listeners:

    // TODO: replace with vulcan, site specific behaviors - this will return nothing currently now that we're using the new platform
    const analyticsBehavior = {};
    const events = [
      'addToCart',
      'addToFavorites',
      'checkoutOPC',
      'checkoutSampleAdded',
      'emailSignup',
      'getRecAIProdData',
      'liveChatManualInitiated',
      'liveChatManualPreSurvey',
      'liveChatManualWaiting',
      'liveChatManualChatting',
      'liveChatProactiveDisplayed',
      'liveChatProactiveInitiated',
      'liveChatProactivePreSurvey',
      'liveChatProactiveWaiting',
      'liveChatProactiveChatting',
      'offerFailed',
      'offerSuccessful',
      'profileUpdate',
      'registration',
      'removeFromCart',
      'searchPageLoaded',
      'searchPredicted',
      'searchRedirect',
      'signin',
      'signinFailed',
      'emailWishlist',
      'productThumbnailClick',
      'cancelOrder'
    ];

    for (let i = 0; i < events.length; i++) {
      // Try brand function first
      //  - otherwise try the global function
      const callback = analyticsBehavior[events[i]] || site.track[events[i]];
      site.elcEvents.addListener('track:' + events[i], (customEvent) =>
        callback(customEvent?.detail)
      );
    }

    */
